export default __webpack_public_path__ + "static/media/vuesax-linear-video-square.a1d9f99f.svg";